import { Component, ViewEncapsulation } from '@angular/core';
import { AppStateService } from '../../../core/services/app-state.service';

@Component({
  selector: 'vota-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent {
  constructor(public appStateService: AppStateService) {}

  toggleSidebar(): void {
    this.appStateService.toggleSidebar();
  }
}
